<div id="dashboard-admin"
    #dashboardAdminRoot
    class="page-layout simple right-sidebar"
    [class.dashboard-admin--fullscreen]="dashboardFullscreen"
    [class.dashboard-admin--modal-open]="isDashboardModalOpen"
    fxLayout="row">

    <div class="center" fxLayout="column">

        <div class="content" #dashboardContentScroll fxFlex fusePerfectScrollbar>

            <!-- BLOCO QUE SOME NO SCROLL -->

            <!-- BLOCO FIXO -->
            <div class="dashboard-filter-sticky">
                <div class="dashboard-filter-toolbar"
                    fxLayout="row"
                    fxLayout.lt-sm="column"
                    fxLayoutAlign="space-between center"
                    fxLayoutAlign.lt-sm="start stretch"
                    fxLayoutGap="8px">

                    <div class="dashboard-filter-toolbar__left"
                        fxLayout="row"
                        fxLayoutAlign="start center"
                        fxLayoutGap="8px">

                        <button mat-stroked-button
                            class="dashboard-filter-actions-desktop"
                            type="button"
                            [disabled]="!dashboardFiltersEnabled"
                            (click)="openGlobalFilters()">
                            <mat-icon>filter_alt</mat-icon>
                            Filtros gerais
                        </button>

                        <button mat-stroked-button
                            class="dashboard-filter-actions-desktop"
                            type="button"
                            (click)="openDashboardPreferences()">
                            <mat-icon>star</mat-icon>
                            Favoritos
                        </button>

                        <button mat-stroked-button
                            class="dashboard-filter-actions-desktop"
                            type="button"
                            (click)="openDashboardOrder()">
                            <mat-icon>dashboard_customize</mat-icon>
                            Organizar
                        </button>

                        <button mat-stroked-button
                            class="dashboard-mobile-actions-trigger"
                            type="button"
                            aria-label="Abrir ações do dashboard"
                            [matMenuTriggerFor]="dashboardMobileActionsMenu">
                            <mat-icon>menu</mat-icon>
                        </button>

                        <mat-menu #dashboardMobileActionsMenu="matMenu">
                            <button mat-menu-item
                                type="button"
                                [disabled]="!dashboardFiltersEnabled"
                                (click)="openGlobalFilters()">
                                <mat-icon>filter_alt</mat-icon>
                                <span>Filtros gerais</span>
                            </button>

                            <button mat-menu-item
                                type="button"
                                (click)="openDashboardPreferences()">
                                <mat-icon>star</mat-icon>
                                <span>Favoritos</span>
                            </button>

                            <button mat-menu-item
                                type="button"
                                (click)="openDashboardOrder()">
                                <mat-icon>dashboard_customize</mat-icon>
                                <span>Organizar</span>
                            </button>
                        </mat-menu>

                        <button mat-stroked-button
                            class="dashboard-fullscreen-action"
                            type="button"
                            (click)="toggleDashboardFullscreen()">
                            <mat-icon>{{ dashboardFullscreen ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
                            {{ dashboardFullscreen ? 'Tela normal' : 'Tela cheia' }}
                        </button>

                        <span class="dashboard-filter-summary">
                            {{ getGlobalFilterSummary() }}
                        </span>
                    </div>

                    <div class="dashboard-filter-panel-actions"
                        fxLayout="row"
                        fxLayoutAlign="end center"
                        fxLayoutGap="8px">

                        <button *ngIf="!dashboardPanelsExpanded"
                            mat-stroked-button
                            type="button"
                            (click)="expandAllDashboards()">
                            <mat-icon>unfold_more</mat-icon>
                            Expandir tudo
                        </button>

                        <button *ngIf="dashboardPanelsExpanded"
                            mat-stroked-button
                            type="button"
                            (click)="collapseAllDashboards()">
                            <mat-icon>unfold_less</mat-icon>
                            Fechar tudo
                        </button>
                    </div>
                </div>

                <div class="dashboard-filter-overlay"
                    *ngIf="globalFiltersVisible"
                    (wheel)="blockDashboardModalScroll($event)"
                    (touchmove)="blockDashboardModalScroll($event)"
                    (click)="closeGlobalFilters()">

                    <div class="dashboard-filter-modal dashboard-general-filter-modal"
                        (click)="$event.stopPropagation()">

                        <div class="dashboard-filter-modal__header"
                            fxLayout="row"
                            fxLayoutAlign="space-between center"
                            fxLayoutGap="12px">

                            <div class="dashboard-filter-modal__title"
                                fxLayout="row"
                                fxLayoutAlign="start center"
                                fxLayoutGap="8px">
                                <mat-icon>filter_alt</mat-icon>
                                <span>Filtros gerais</span>
                            </div>

                            <button mat-icon-button type="button" (click)="closeGlobalFilters()">
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>

                        <div class="dashboard-filter-menu__content"
                            [formGroup]="filterForm">

                            <div class="dashboard-filter-menu__grid">
                                <mat-form-field appearance="outline">
                                    <mat-label>Aplicar filtro em</mat-label>

                                    <mat-select formControlName="filterTarget" multiple>
                                        <mat-option value="ALL">Todos</mat-option>

                                        <mat-option *ngFor="let item of availableDashboardPermissions" [value]="item.code">
                                            {{ item.name }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>Período</mat-label>

                                    <mat-date-range-input [rangePicker]="picker" [min]="minDate" [max]="maxDate">
                                        <input matStartDate placeholder="Data inicial" formControlName="startDate">
                                        <input matEndDate placeholder="Data final" formControlName="endDate">
                                    </mat-date-range-input>

                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>

                                    <button mat-icon-button matSuffix type="button"
                                        *ngIf="filterForm.get('startDate')?.value || filterForm.get('endDate')?.value"
                                        (click)="clearDateRange()">
                                        <mat-icon>close</mat-icon>
                                    </button>

                                    <mat-date-range-picker #picker></mat-date-range-picker>
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>Mês/Ano dos dashboards anuais</mat-label>

                                    <input matInput
                                        readonly
                                        [value]="getDashboardMonthYearDisplay()"
                                        (click)="dashboardMonthYearPicker.open()">

                                    <input class="dashboard-month-year-picker-anchor"
                                        tabindex="-1"
                                        aria-hidden="true"
                                        [matDatepicker]="dashboardMonthYearPicker">

                                    <mat-datepicker-toggle matSuffix
                                        [for]="dashboardMonthYearPicker">
                                    </mat-datepicker-toggle>

                                    <mat-datepicker #dashboardMonthYearPicker
                                        startView="multi-year"
                                        [startAt]="dashboardMonthYearDate"
                                        (monthSelected)="setDashboardMonthAndYear($event, dashboardMonthYearPicker)"
                                        panelClass="example-month-picker">
                                    </mat-datepicker>
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>Empresa</mat-label>

                                    <input matInput [matAutocomplete]="autoCompany" formControlName="company"
                                        autocomplete="off" type="search" />

                                    <button mat-icon-button matSuffix type="button" *ngIf="filterForm.get('company')?.value"
                                        (click)="filterForm.get('company')?.setValue(null)">
                                        <mat-icon>close</mat-icon>
                                    </button>

                                    <mat-autocomplete #autoCompany="matAutocomplete" [displayWith]="displayCompanyFn"
                                        (optionSelected)="companySelected($event)">
                                        <mat-option *ngFor="let company of companyList" [value]="company">
                                            {{ company.name }}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>Profissional</mat-label>

                                    <input matInput [matAutocomplete]="autoPerformerF" autocomplete="off" type="search"
                                        formControlName="performer" />

                                    <button mat-icon-button matSuffix type="button"
                                        *ngIf="filterForm.get('performer')?.value"
                                        (click)="filterForm.get('performer')?.setValue(null)">
                                        <mat-icon>close</mat-icon>
                                    </button>

                                    <mat-autocomplete #autoPerformerF="matAutocomplete" [displayWith]="displayFn"
                                        (optionSelected)="performerSelected($event)">
                                        <mat-option *ngFor="let performer of performerList" [value]="performer">
                                            {{ performer.professional?.person?.name || performer.person?.name }}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>Usuário</mat-label>

                                    <input matInput
                                        [matAutocomplete]="autoDashboardUser"
                                        autocomplete="off"
                                        type="search"
                                        formControlName="user" />

                                    <button mat-icon-button
                                        matSuffix
                                        type="button"
                                        *ngIf="canSelectDashboardUserFilter && filterForm.get('user')?.value"
                                        (click)="filterForm.get('user')?.setValue(null)">
                                        <mat-icon>close</mat-icon>
                                    </button>

                                    <mat-autocomplete #autoDashboardUser="matAutocomplete"
                                        [displayWith]="displayDashboardUserFn">
                                        <mat-option *ngFor="let dashboardUser of dashboardUserList" [value]="dashboardUser">
                                            {{ getDashboardUserName(dashboardUser) }}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </div>

                            <div class="dashboard-filter-menu__actions"
                                fxLayout="row"
                                fxLayoutAlign="end center"
                                fxLayoutGap="8px">

                                <button mat-stroked-button type="button" (click)="clearAll()">
                                    <mat-icon>clear</mat-icon>
                                    Limpar
                                </button>

                                <button mat-raised-button type="button" color="primary" (click)="applyGlobalFilters()">
                                    Aplicar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="dashboard-filter-overlay"
                    *ngIf="dashboardPreferenceVisible"
                    (wheel)="blockDashboardModalScroll($event)"
                    (touchmove)="blockDashboardModalScroll($event)"
                    (click)="closeDashboardPreferences()">

                    <div class="dashboard-filter-modal dashboard-preference-modal"
                        (click)="$event.stopPropagation()">

                        <div class="dashboard-filter-modal__header"
                            fxLayout="row"
                            fxLayoutAlign="space-between center"
                            fxLayoutGap="12px">

                            <div class="dashboard-filter-modal__title"
                                fxLayout="row"
                                fxLayoutAlign="start center"
                                fxLayoutGap="8px">
                                <mat-icon>dashboard_customize</mat-icon>
                                <span>Dashboards da {{ currentDashboardTabName }}</span>
                            </div>

                            <button mat-icon-button
                                type="button"
                                [disabled]="dashboardPreferencesSaving"
                                (click)="closeDashboardPreferences()">
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>

                        <div class="dashboard-preference-content">
                            <div class="dashboard-preference-intro"
                                fxLayout="row"
                                fxLayout.lt-sm="column"
                                fxLayoutAlign="space-between center"
                                fxLayoutAlign.lt-sm="start stretch"
                                fxLayoutGap="12px">

                                <div>
                                    <div class="dashboard-preference-intro__title">
                                        {{ getDashboardPreferenceSummary() }}
                                    </div>
                                    <div class="dashboard-preference-intro__subtitle">
                                        A lista mostra apenas dashboards liberados para o seu perfil.
                                    </div>
                                </div>

                                <div fxLayout="row"
                                    fxLayoutAlign="end center"
                                    fxLayoutGap="8px">
                                    <button mat-stroked-button
                                        type="button"
                                        [disabled]="dashboardPreferencesLoading || dashboardPreferencesSaving"
                                        (click)="selectAllDashboardPreferences()">
                                        <mat-icon>select_all</mat-icon>
                                        Marcar todos
                                    </button>

                                    <button mat-stroked-button
                                        type="button"
                                        [disabled]="dashboardPreferencesLoading || dashboardPreferencesSaving"
                                        (click)="clearDashboardPreferences()">
                                        <mat-icon>clear_all</mat-icon>
                                        Desmarcar
                                    </button>
                                </div>
                            </div>

                            <div *ngIf="dashboardPreferencesLoading"
                                class="dashboard-preference-loading"
                                fxLayout="row"
                                fxLayoutAlign="center center"
                                fxLayoutGap="10px">
                                <mat-progress-spinner mode="indeterminate" diameter="28" strokeWidth="4">
                                </mat-progress-spinner>
                                <span>Carregando preferências</span>
                            </div>

                            <div *ngIf="!dashboardPreferencesLoading && !availableDashboardPermissions.length"
                                class="dashboard-preference-empty">
                                Nenhum dashboard disponível para vínculo nesta aba.
                            </div>

                            <div *ngIf="!dashboardPreferencesLoading && availableDashboardPermissions.length"
                                class="dashboard-preference-list">

                                <div *ngFor="let item of availableDashboardPermissions"
                                    class="dashboard-preference-item"
                                    role="button"
                                    tabindex="0"
                                    [class.dashboard-preference-item--selected]="isDashboardPreferenceSelected(item.code)"
                                    (click)="toggleDashboardPreferenceItem(item.code)"
                                    (keydown.enter)="toggleDashboardPreferenceItem(item.code)"
                                    (keydown.space)="$event.preventDefault(); toggleDashboardPreferenceItem(item.code)">

                                    <mat-checkbox
                                        [checked]="isDashboardPreferenceSelected(item.code)"
                                        [disabled]="dashboardPreferencesSaving"
                                        (click)="$event.stopPropagation()"
                                        (change)="toggleDashboardPreference(item.code, $event.checked)">
                                    </mat-checkbox>

                                    <div class="dashboard-preference-item__body">
                                        <div class="dashboard-preference-item__name">
                                            {{ item.name }}
                                        </div>
                                        <div class="dashboard-preference-item__description">
                                            {{ item.description || item.code }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="dashboard-filter-menu__actions"
                                fxLayout="row"
                                fxLayoutAlign="end center"
                                fxLayoutGap="8px">

                                <button mat-stroked-button
                                    type="button"
                                    [disabled]="dashboardPreferencesSaving"
                                    (click)="closeDashboardPreferences()">
                                    Cancelar
                                </button>

                                <button mat-raised-button
                                    type="button"
                                    color="primary"
                                    [disabled]="dashboardPreferencesLoading || dashboardPreferencesSaving"
                                    (click)="saveDashboardPreferences()">
                                    <mat-icon>save</mat-icon>
                                    Salvar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

                <div class="dashboard-filter-overlay"
                    *ngIf="dashboardOrderVisible"
                    (wheel)="blockDashboardModalScroll($event)"
                    (touchmove)="blockDashboardModalScroll($event)"
                    (click)="closeDashboardOrder()">

                    <div class="dashboard-filter-modal dashboard-order-modal"
                        (click)="$event.stopPropagation()"
                        (wheel)="$event.stopPropagation()"
                        (touchmove)="$event.stopPropagation()">

                        <div class="dashboard-filter-modal__header"
                            fxLayout="row"
                            fxLayoutAlign="space-between center"
                            fxLayoutGap="12px">

                            <div class="dashboard-filter-modal__title"
                                fxLayout="row"
                                fxLayoutAlign="start center"
                                fxLayoutGap="8px">
                                <mat-icon>dashboard_customize</mat-icon>
                                <span>Organizar dashboards e abas</span>
                            </div>

                            <button mat-icon-button
                                type="button"
                                [disabled]="dashboardPreferencesSaving"
                                (click)="closeDashboardOrder()">
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>

                        <div class="dashboard-order-content">
                            <mat-tab-group class="dashboard-order-tabs" animationDuration="150ms">
                                <mat-tab>
                                    <ng-template mat-tab-label>
                                        <mat-icon>view_week</mat-icon>
                                        <span>Organizar abas</span>
                                    </ng-template>

                                    <div class="dashboard-order-tab-body">
                                        <div class="dashboard-order-section">
                                            <div class="dashboard-order-section__header">
                                                <div class="dashboard-order-intro__title">
                                                    Ordem das abas
                                                </div>
                                                <div class="dashboard-order-intro__subtitle">
                                                    Arraste para definir qual aba aparece primeiro na tela.
                                                </div>
                                            </div>

                                            <div *ngIf="!dashboardTabOrderDraft.length"
                                                class="dashboard-preference-empty">
                                                Nenhuma aba disponível para organizar.
                                            </div>

                                            <div *ngIf="dashboardTabOrderDraft.length"
                                                class="dashboard-tab-order-list"
                                                cdkDropList
                                                [cdkDropListData]="dashboardTabOrderDraft"
                                                (cdkDropListDropped)="dropDashboardTabOrder($event)">

                                                <div *ngFor="let tab of dashboardTabOrderDraft; let index = index"
                                                    class="dashboard-order-item dashboard-tab-order-item"
                                                    cdkDrag
                                                    [cdkDragDisabled]="dashboardPreferencesSaving">

                                                    <div class="dashboard-order-item__position">
                                                        {{ index + 1 }}
                                                    </div>

                                                    <button mat-icon-button
                                                        type="button"
                                                        class="dashboard-order-item__drag"
                                                        cdkDragHandle>
                                                        <mat-icon>drag_indicator</mat-icon>
                                                    </button>

                                                    <div class="dashboard-order-item__body">
                                                        <div class="dashboard-order-item__name"
                                                            fxLayout="row"
                                                            fxLayoutAlign="start center"
                                                            fxLayoutGap="8px">
                                                            <mat-icon>{{ getTabIcon(tab.code) }}</mat-icon>
                                                            <span>{{ tab.name }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </mat-tab>

                                <mat-tab>
                                    <ng-template mat-tab-label>
                                        <mat-icon>dashboard_customize</mat-icon>
                                        <span>Organizar dashboards</span>
                                    </ng-template>

                                    <div class="dashboard-order-tab-body">
                                        <div class="dashboard-order-section">
                                            <div class="dashboard-order-intro"
                                                fxLayout="row"
                                                fxLayout.lt-sm="column"
                                                fxLayoutAlign="space-between center"
                                                fxLayoutAlign.lt-sm="start stretch"
                                                fxLayoutGap="12px">

                                                <div>
                                                    <div class="dashboard-order-intro__title">
                                                        {{ dashboardOrderDraft.length }} dashboard(s) visível(is)
                                                    </div>
                                                    <div class="dashboard-order-intro__subtitle">
                                                        Arraste os dashboards da aba atual e escolha o tamanho de cada um.
                                                    </div>
                                                </div>

                                                <div *ngIf="hiddenDashboardPreferenceCount"
                                                    class="dashboard-order-hidden-note">
                                                    {{ hiddenDashboardPreferenceCount }} oculto(s) em Favoritos
                                                </div>
                                            </div>

                                            <div *ngIf="dashboardPreferencesLoading"
                                                class="dashboard-preference-loading"
                                                fxLayout="row"
                                                fxLayoutAlign="center center"
                                                fxLayoutGap="10px">
                                                <mat-progress-spinner mode="indeterminate" diameter="28" strokeWidth="4">
                                                </mat-progress-spinner>
                                                <span>Carregando organizacao</span>
                                            </div>

                                            <div *ngIf="!dashboardPreferencesLoading && !orderedDashboardPreferenceItems.length"
                                                class="dashboard-preference-empty">
                                                Nenhum dashboard visível para organizar nesta aba.
                                            </div>

                                            <div *ngIf="!dashboardPreferencesLoading && orderedDashboardPreferenceItems.length"
                                                class="dashboard-order-list"
                                                cdkDropList
                                                [cdkDropListData]="dashboardOrderDraft"
                                                (cdkDropListDropped)="dropDashboardOrder($event)">

                                                <div *ngFor="let item of orderedDashboardPreferenceItems; let index = index"
                                                    class="dashboard-order-item"
                                                    cdkDrag
                                                    [cdkDragDisabled]="dashboardPreferencesSaving">

                                                    <div class="dashboard-order-item__position">
                                                        {{ index + 1 }}
                                                    </div>

                                                    <button mat-icon-button
                                                        type="button"
                                                        class="dashboard-order-item__drag"
                                                        cdkDragHandle>
                                                        <mat-icon>drag_indicator</mat-icon>
                                                    </button>

                                                    <div class="dashboard-order-item__body">
                                                        <div class="dashboard-order-item__name">
                                                            {{ item.name }}
                                                        </div>
                                                        <div class="dashboard-order-item__description">
                                                            {{ item.description || item.code }}
                                                        </div>
                                                    </div>

                                                    <div class="dashboard-order-item__layout">
                                                        <div class="dashboard-order-item__layout-title">
                                                            Tamanho na tela
                                                        </div>

                                                        <div class="dashboard-layout-options">
                                                            <button *ngFor="let option of getDashboardLayoutOptions(item)"
                                                                type="button"
                                                                class="dashboard-layout-option"
                                                                [class.dashboard-layout-option--selected]="isDashboardLayoutSelected(item.code, option.columns)"
                                                                [disabled]="dashboardPreferencesSaving"
                                                                (click)="setDashboardLayoutColumns(item.code, option.columns)">
                                                                <mat-icon>{{ option.icon }}</mat-icon>
                                                                <span class="dashboard-layout-option__text">
                                                                    <b>{{ option.label }}</b>
                                                                    <small>{{ option.description }}</small>
                                                                </span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </mat-tab>
                            </mat-tab-group>

                            <div class="dashboard-filter-menu__actions"
                                fxLayout="row"
                                fxLayoutAlign="end center"
                                fxLayoutGap="8px">

                                <button mat-stroked-button
                                    type="button"
                                    [disabled]="dashboardPreferencesSaving"
                                    (click)="closeDashboardOrder()">
                                    Cancelar
                                </button>

                                <button mat-raised-button
                                    type="button"
                                    color="primary"
                                    [disabled]="dashboardPreferencesLoading || dashboardPreferencesSaving || !dashboardTabOrderDraft.length"
                                    (click)="saveDashboardOrder()">
                                    <mat-icon>save</mat-icon>
                                    Salvar organizacao
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            <!-- CONTEÚDO -->
            <div class="dashboard-tabs-shell">
                <mat-tab-group class="dashboard-tabs" [disableRipple]="true" dynamicHeight mat-stretch-tabs animationDuration="250ms"
                    [selectedIndex]="selectedDashboardTabIndex"
                    (selectedTabChange)="onTabChange($event)">

                    <mat-tab *ngFor="let tab of tabDashboardList; trackBy: trackDashboardTabByCode">

                        <ng-template mat-tab-label>
                            <div class="dashboard-tab-label" fxLayout="row" fxLayoutAlign="center center"
                                fxLayoutGap="8px">
                                <mat-icon class="dashboard-tab-label__icon">
                                    {{ getTabIcon(tab.code) }}
                                </mat-icon>
                                <span class="dashboard-tab-label__text">{{ tab.name }}</span>
                            </div>
                        </ng-template>

                        <div class="dashboard-tab-panel" *ngIf="tab.code === currentDashboardTabCode">
                            <div class="dashboard-tab-content-anchor"></div>

                            <ng-container *ngIf="tab.code === 'application-dashboards-admin-schedule'">
                                <div class="widget-group p-12" fxLayout="row wrap" fxFlex="100" *fuseIfOnDom
                                    [@animateStagger]="{value:'50'}">
                                    <app-dashboard-schedule style="width: 100%;" [company]="selectedCompany"
                                        [filterData]="filterData" [permissions]="dashboardPermissions"
                                        [expandCommand]="dashboardExpansionCommand"
                                        [filtersEnabled]="dashboardFiltersEnabled">
                                    </app-dashboard-schedule>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="tab.code === 'application-dashboards-admin-reception'">
                                <div class="widget-group p-12" fxLayout="row wrap" fxFlex="100" *fuseIfOnDom
                                    [@animateStagger]="{value:'50'}">
                                    <app-dashboard-order style="width: 100%;" [company]="selectedCompany"
                                        [filterData]="filterData" [permissions]="dashboardPermissions"
                                        [expandCommand]="dashboardExpansionCommand"
                                        [filtersEnabled]="dashboardFiltersEnabled" dashboardType="RC">
                                    </app-dashboard-order>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="tab.code === 'application-dashboards-admin-order'">
                                <div class="widget-group p-12" fxLayout="row wrap" fxFlex="100" *fuseIfOnDom
                                    [@animateStagger]="{value:'50'}">
                                    <app-dashboard-order style="width: 100%;" [company]="selectedCompany"
                                        [filterData]="filterData" [permissions]="dashboardPermissions"
                                        [expandCommand]="dashboardExpansionCommand"
                                        [filtersEnabled]="dashboardFiltersEnabled">
                                    </app-dashboard-order>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="tab.code === 'application-dashboards-admin-billing'">
                                <div class="widget-group p-12" fxLayout="row wrap" fxFlex="100" *fuseIfOnDom
                                    [@animateStagger]="{value:'50'}">
                                    <app-dashboard-order style="width: 100%;" [company]="selectedCompany"
                                        [filterData]="filterData" [permissions]="dashboardPermissions"
                                        [expandCommand]="dashboardExpansionCommand"
                                        [filtersEnabled]="dashboardFiltersEnabled" dashboardType="FT">
                                    </app-dashboard-order>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="tab.code === 'application-dashboards-admin-financial'">
                                <div class="widget-group p-12" fxLayout="row wrap" fxFlex="100" *fuseIfOnDom
                                    [@animateStagger]="{value:'50'}">
                                    <app-dashboard-order style="width: 100%;" [company]="selectedCompany"
                                        [filterData]="filterData" [permissions]="dashboardPermissions"
                                        [expandCommand]="dashboardExpansionCommand"
                                        [filtersEnabled]="dashboardFiltersEnabled" dashboardType="FI">
                                    </app-dashboard-order>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="tab.code === 'application-dashboards-admin-managerial'">
                                <div class="widget-group p-12" fxLayout="row wrap" fxFlex="100" *fuseIfOnDom
                                    [@animateStagger]="{value:'50'}">
                                    <app-dashboard-order style="width: 100%;" [company]="selectedCompany"
                                        [filterData]="filterData" [permissions]="dashboardPermissions"
                                        [expandCommand]="dashboardExpansionCommand"
                                        [filtersEnabled]="dashboardFiltersEnabled" dashboardType="GE">
                                    </app-dashboard-order>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="tab.code === 'application-dashboards-admin-performer'">
                                <div class="widget-group p-12" fxLayout="row wrap" fxFlex="100" *fuseIfOnDom
                                    [@animateStagger]="{value:'50'}">
                                    <app-dashboard-performer style="width: 100%;" [company]="selectedCompany"
                                        [performer]="performer">
                                    </app-dashboard-performer>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="tab.code === 'application-dashboards-admin-user'">
                                <div class="widget-group" fxLayout="row wrap" fxFlex="100" *fuseIfOnDom
                                    [@animateStagger]="{value:'50'}">

                                    <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="widget"
                                        fxLayout="row" fxFlex="100">

                                        <div class="fuse-widget-front">
                                            <div class="p-24 mb-8 border-bottom" fxLayout="row"
                                                fxLayoutAlign="space-between center">
                                                <div class="h2">Sessões ativas</div>
                                                <div *ngIf="dataSource.data?.length > 1" class="text-boxed accent m-0">
                                                    {{dataSource.data?.length}} sessões
                                                </div>
                                                <div *ngIf="dataSource.data?.length == 1" class="text-boxed accent m-0">
                                                    {{dataSource.data?.length}} sessão
                                                </div>
                                            </div>

                                            <mat-table #table [dataSource]="dataSource">
                                                <ng-container matColumnDef="avatar">
                                                    <mat-header-cell fxFlex="96px" *matHeaderCellDef></mat-header-cell>
                                                    <mat-cell fxFlex="96px" *matCellDef="let user">
                                                        <img class="avatar" [alt]="user.name"
                                                            [src]="user.photo ? 'data:image/jpg;base64,' + user.photo : 'assets/images/avatars/profile.jpg'" />
                                                    </mat-cell>
                                                </ng-container>

                                                <ng-container matColumnDef="name">
                                                    <mat-header-cell *matHeaderCellDef>Nome</mat-header-cell>
                                                    <mat-cell *matCellDef="let user">
                                                        <p class="text-truncate font-weight-600">{{user.login}}</p>
                                                    </mat-cell>
                                                </ng-container>

                                                <ng-container matColumnDef="date">
                                                    <mat-header-cell *matHeaderCellDef fxHide fxShow.gt-sm>
                                                        Quando
                                                    </mat-header-cell>
                                                    <mat-cell *matCellDef="let user" fxHide fxShow.gt-sm>
                                                        {{ getDate(user.accessDate) }}
                                                    </mat-cell>
                                                </ng-container>

                                                <ng-container matColumnDef="ip">
                                                    <mat-header-cell *matHeaderCellDef fxHide fxShow.gt-md>
                                                        Endereço IP
                                                    </mat-header-cell>
                                                    <mat-cell *matCellDef="let user" fxHide fxShow.gt-md>
                                                        <p class="phone text-truncate">{{user.ip}}</p>
                                                    </mat-cell>
                                                </ng-container>

                                                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                                                <mat-row *matRowDef="let user; columns: displayedColumns;"></mat-row>
                                            </mat-table>
                                        </div>

                                    </fuse-widget>
                                </div>
                            </ng-container>

                        </div>
                    </mat-tab>
                </mat-tab-group>
            </div>

        </div>
    </div>
</div>
